import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './component/Sidebar';

function Utilisateur(){
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ 
    idadmin: null, 
    email: '', 
    password: '', 
    nom: '', 
    role: 'user',
    acces: {
      commandes: false,
      produit: false,
      categorie: false,
      livreur: false,
      utilisateur: false,
      clients: false,
      footer: false
    }
  });
  const base = 'https://jojomarket.ne/adminfood/';
  
  // Available pages for access control
  const pages = [
    { key: 'commandes', label: 'Commandes', icon: 'ni ni-bullet-list-67' },
    { key: 'produit', label: 'Produit', icon: 'ni ni-bag-17' },
    { key: 'categorie', label: 'Categorie', icon: 'ni ni-collection' },
    { key: 'livreur', label: 'Livreur', icon: 'ni ni-delivery-fast' },
    { key: 'clients', label: 'Clients', icon: 'ni ni-circle-08' },
    { key: 'utilisateur', label: 'Utilisateur', icon: 'ni ni-single-02' },
    { key: 'footer', label: 'Footer', icon: 'ni ni-settings-gear-65' }
  ];

  const loadUsers = async () => {
    const res = await axios.get(base + 'functionuser.php?getusers');
    setUsers(res.data || []);
  };

  useEffect(() => {
    if(!sessionStorage.getItem('Token')){ navigate('/login'); return; }
    loadUsers();
  }, []);

  const addUser = async () => {
    if(!form.email || !form.password || !form.nom){ alert('Complétez le formulaire'); return; }
    const accesJson = JSON.stringify(form.acces);
    const url = `${base}functionuser.php?adduser&email=${encodeURIComponent(form.email)}&password=${encodeURIComponent(form.password)}&nom=${encodeURIComponent(form.nom)}&role=${encodeURIComponent(form.role || 'user')}&acces=${encodeURIComponent(accesJson)}`;
    await axios.get(url);
    setForm({ 
      idadmin: null, 
      email: '', 
      password: '', 
      nom: '', 
      role: 'user',
      acces: {
        commandes: false,
        produit: false,
        categorie: false,
        livreur: false,
        utilisateur: false,
        clients: false,
        footer: false
      }
    });
    loadUsers();
  };

  const openEdit = (u) => {
    setForm({ 
      idadmin: u.idadmin, 
      email: u.email, 
      password: '', 
      nom: u.nom, 
      role: u.post || 'user',
      acces: {
        commandes: u.acces?.commandes || false,
        produit: u.acces?.produit || false,
        categorie: u.acces?.categorie || false,
        livreur: u.acces?.livreur || false,
        utilisateur: u.acces?.utilisateur || false,
        clients: u.acces?.clients || false,
        footer: u.acces?.footer || false
      }
    });
    const modal = new window.bootstrap.Modal(document.getElementById('editUserModal'));
    modal.show();
  };

  const updateUser = async () => {
    if(!form.idadmin){ return; }
    const accesJson = JSON.stringify(form.acces);
    const url = `${base}functionuser.php?updateuser&idadmin=${form.idadmin}&email=${encodeURIComponent(form.email)}&nom=${encodeURIComponent(form.nom)}&role=${encodeURIComponent(form.role)}&acces=${encodeURIComponent(accesJson)}${form.password ? `&password=${encodeURIComponent(form.password)}` : ''}`;
    await axios.get(url);
    loadUsers();
  };

  const toggleAcces = (pageKey) => {
    setForm({
      ...form,
      acces: {
        ...form.acces,
        [pageKey]: !form.acces[pageKey]
      }
    });
  };

  const deleteUser = async (id) => {
    if(!window.confirm('Supprimer cet utilisateur ?')) return;
    await axios.get(base + 'functionuser.php?deleteuser&idadmin=' + id);
    loadUsers();
  };

  return (
    <div>
      <Sidebar/>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
          <div className="container-fluid py-1 px-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
                <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Utilisateur</li>
              </ol>
              <h6 className="font-weight-bolder mb-0">Gestion Utilisateurs</h6>
            </nav>
          </div>
        </nav>
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                <h6>Utilisateurs</h6>
                <Link className="btn btn-sm btn-outline-primary" to="/home">Retour</Link>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="table-responsive">
                  <table className="table align-items-center mb-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nom</th>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Email</th>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Rôle</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Accès</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users && users.map(u => (
                        <tr key={u.idadmin}>
                          <td><span className="text-xs font-weight-bold">{u.nom}</span></td>
                          <td><span className="text-xs">{u.email}</span></td>
                          <td><span className="badge bg-info text-uppercase">{u.post || 'N/A'}</span></td>
                          <td className="text-center">
                            <div className="d-flex flex-wrap gap-1 justify-content-center">
                              {pages.map(page => {
                                const hasAccess = u.acces && u.acces[page.key] === true;
                                return hasAccess ? (
                                  <span key={page.key} className="badge bg-success badge-sm me-1">
                                    {page.label}
                                  </span>
                                ) : null;
                              })}
                              {(!u.acces || Object.values(u.acces || {}).every(v => !v)) && (
                                <span className="badge bg-secondary badge-sm">Aucun accès</span>
                              )}
                            </div>
                          </td>
                          <td className="text-center">
                            <div className="btn-group btn-group-sm">
                              <button className="btn btn-outline-warning" onClick={() => openEdit(u)}>Modifier</button>
                              <button className="btn btn-outline-danger" onClick={() => deleteUser(u.idadmin)}>Supprimer</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <div className="card-header pb-0"><h6>Ajouter un utilisateur</h6></div>
              <div className="card-body">
                <div className="mb-2">
                  <label className="form-label">Nom</label>
                  <input className="form-control" value={form.nom} onChange={e => setForm({...form, nom: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Email</label>
                  <input className="form-control" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Mot de passe</label>
                  <input className="form-control" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
                </div>
                <div className="mb-2">
                  <label className="form-label">Rôle</label>
                  <input className="form-control" value={form.role} onChange={e => setForm({...form, role: e.target.value})} placeholder="Ex: admin, caissier..." />
                </div>
                <div className="mb-3">
                  <label className="form-label">Accès aux pages</label>
                  <div className="border rounded p-2" style={{maxHeight: '200px', overflowY: 'auto'}}>
                    {pages.map(page => (
                      <div key={page.key} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`acces-${page.key}`}
                          checked={form.acces[page.key] || false}
                          onChange={() => toggleAcces(page.key)}
                        />
                        <label className="form-check-label" htmlFor={`acces-${page.key}`}>
                          {page.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <button className="btn btn-primary w-100" onClick={addUser}>Enregistrer</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit modal */}
      <div className="modal fade" id="editUserModal" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modifier utilisateur</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">Nom</label>
                <input className="form-control" value={form.nom} onChange={e => setForm({...form, nom: e.target.value})} />
              </div>
              <div className="mb-2">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
              </div>
              <div className="mb-2">
                <label className="form-label">Nouveau mot de passe (optionnel)</label>
                <input className="form-control" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
              </div>
              <div className="mb-2">
                <label className="form-label">Rôle</label>
                <input className="form-control" value={form.role} onChange={e => setForm({...form, role: e.target.value})} placeholder="Ex: admin, caissier..." />
              </div>
              <div className="mb-3">
                <label className="form-label">Accès aux pages</label>
                <div className="border rounded p-2" style={{maxHeight: '200px', overflowY: 'auto'}}>
                  {pages.map(page => (
                    <div key={page.key} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`edit-acces-${page.key}`}
                        checked={form.acces[page.key] || false}
                        onChange={() => toggleAcces(page.key)}
                      />
                      <label className="form-check-label" htmlFor={`edit-acces-${page.key}`}>
                        {page.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
              <button type="button" className="btn btn-primary" onClick={updateUser} data-bs-dismiss="modal">Enregistrer</button>
            </div>
          </div>
        </div>
      </div>
      </main>
    </div>
  );
}

export default Utilisateur;


